import React, { Component } from 'react';
import { Field } from 'redux-form/immutable';

import { Col, Row } from 'react-flexbox-grid';
import RaisedButton from 'material-ui/RaisedButton';

import { validateConstraints, validationImmutableReduxForm } from '../../../components/FormWrapper';

import { TextField } from 'redux-form-material-ui';

const formValidation = values =>
    validateConstraints(values.toJS(), {
        companyName: {
            presence: {
                message: '^Bitte geben Sie Ihren Firmennamen an',
                allowEmpty: false,
            },
        },
        email: {
            presence: {
                message: '^Bitte geben Sie eine E-Mail-Adresse ein',
                allowEmpty: false,
            },
        },
        postalCode: {
            presence: {
                message: '^Bitte geben Sie eine Postleitzahl ein',
                allowEmpty: false,
            },
        },
        street: {
            presence: {
                message: '^Bitte geben Sie eine Straße ein',
                allowEmpty: false,
            },
        },
        city: {
            presence: {
                message: '^Bitte geben Sie eine Stadt ein',
                allowEmpty: false,
            },
        },
    });

export class AddressForm extends Component {
    render() {
        const { handleSubmit, pristine, reset, submitting } = this.props;
        return (
            <div>
                <h3>Adresse</h3>
                <form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={12} sm={12} xs={12}>
                            <Field
                                name="companyName"
                                component={TextField}
                                type="text"
                                style={{ width: '100%' }}
                                floatingLabelText="Firma"
                                label="Firma"
                            />
                            <Field
                                name="email"
                                component={TextField}
                                type="text"
                                style={{ width: '100%' }}
                                floatingLabelText="E-Mail-Adresse"
                                label="E-Mail-Adresse"
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: '40px' }}>
                        <Col md={12} sm={12} xs={12}>
                            <h3>Rechnungsadresse</h3>
                            <Row>
                                <Col md={12} sm={12} xs={12}>
                                    <Field
                                        name="street"
                                        component={TextField}
                                        type="text"
                                        style={{ width: '100%' }}
                                        floatingLabelText="Straße"
                                        label="Straße"
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={8} sm={8} xs={8}>
                                    <Field
                                        name="city"
                                        component={TextField}
                                        type="text"
                                        style={{ width: '100%' }}
                                        floatingLabelText="Stadt"
                                        label="Stadt"
                                    />
                                </Col>
                                <Col md={4} sm={4} xs={4}>
                                    <Field
                                        name="postalCode"
                                        component={TextField}
                                        type="text"
                                        style={{ width: '100%' }}
                                        floatingLabelText="PLZ"
                                        label="PLZ"
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: '30px' }}>
                        <Col xs={12}>
                            <Row end="xs">
                                <Col xs={5}>
                                    <RaisedButton
                                        label="Speichern"
                                        disabled={pristine}
                                        primary={true}
                                        type="submit"
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </form>
            </div>
        );
    }
}

export default validationImmutableReduxForm('addressForm', formValidation)(AddressForm);
